import type {
  // CollaboratorJsonldReadCollectionAgency,
  // CollaboratorJsonldReadCollectionPeople,
  // CollaboratorJsonldReadCollectionProject,
  CollaboratorJsonldReadItemAgencyItem,
  CollaboratorJsonldReadItemPeople,
  CollaboratorJsonldReadItemProject,
} from "@/networking/api"
import type { LocalRefLabel } from "@/utils/i18n/t11n"

export type RelatedCollaborator =
  // | CollaboratorJsonldReadCollectionProject
  // | CollaboratorJsonldReadCollectionAgency
  // | CollaboratorJsonldReadCollectionPeople
  (
    | CollaboratorJsonldReadItemProject
    | CollaboratorJsonldReadItemAgencyItem
    | CollaboratorJsonldReadItemPeople
  ) & {
    function?: string | null
    role?: LocalRefLabel | null
    rank?: LocalRefLabel | null
    isPublished?: boolean | null
    isPublishedInDirectory?: boolean | null
    isDefault?: boolean | null
    relDateOfEntry?: string
    relDateOfLeaving?: string | null
    metadatas?: { [k: string]: string }
    status?: LocalRefLabel | null
  }

/**
export type CollaboratorRelation =
  | ProjectCollaboratorJsonldReadItemProject
  | ProjectCollaboratorJsonldReadCollectionProject
  | RelCollaboratorAgencyJsonldReadCollectionAgency
  | RelCollaboratorAgencyJsonldReadItemAgencyItem
  | RelPeopleCollaboratorJsonldReadCollectionPeople
  | RelPeopleCollaboratorJsonldReadItemPeople
*/

export const COLLABORATOR_STATUS_GROUP = "collaborator:status:"
export const COLLABORATOR_TITLE_GROUP = "collaborator:title:"
export const COLLABORATOR_ROLES = "collaborator:role:"
export const COLLABORATOR_RANK = "collaborator:rank:"

export const COLLABORATOR_PREVIEW_WIDTH = 600
export const COLLABORATOR_SMALL_PREVIEW_WIDTH = 250

export const COLLABORATORS_SORT_COLUMN_DEFAULT = "lastname"
export const COLLABORATORS_SORT_ORDER_DEFAULT = "asc"

export const CollaboratorStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  ARCHIVE: "archive",
  INCREATION: "in-creation",
} as const
export type CollaboratorStatus = (typeof CollaboratorStatus)[keyof typeof CollaboratorStatus]

export const CollaboratorRole = {
  COLLABORATOR: "collaborator",
  MANAGER: "manager",
  NONE: "none",
} as const
export type CollaboratorRole = (typeof CollaboratorRole)[keyof typeof CollaboratorRole]
